export const buildProvenance = { "commitHash": "b00db30a5ba7a24594d5a343d7bb38147a94af83", "branchName": "refs/heads/release/2025.1", "buildDate": "2025-09-18T22:59:50.618Z", "version": "2025.1.10305" };
